import React from "react";
import { Link, useLocation } from "react-router-dom";

const RoutesTabMenu = ({ label, href }) => {
  const route = useLocation();
  const currentLocation = route?.pathname;

  return (
    <Link to={href}>
      <span
        className={`border-b-2 text-base capitalize block py-2 px-4 hover:text-purple-800 hover:transition-all hover:ease-in ease-out transition-all ${
          currentLocation === href
            ? "border-purple-800 text-purple-800 font-semibold"
            : "text-gray-600 border-transparent "
        }`}
      >
        {label}
      </span>
    </Link>
  );
};

const RoutesTabs = ({ data, navExtra }) => {
  return (
    <nav className="bg-transparent w-full overflow-x-auto whitespace-nowrap">
      <div className="w-full flex justify-between rounded-lg">
        <div className="flex items-center">
          {data &&
            data.map((item) => (
              <div className={`${item.id !== 1 ? "ml-5" : null}`} key={item.id}>
                <RoutesTabMenu href={item.href} label={item.name} />
              </div>
            ))}
        </div>

        <div className="flex-1 flex items-center">{navExtra}</div>
      </div>
    </nav>
  );
};

export default RoutesTabs;
